import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../EntityAccount.css';

class CustodianAccountGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.custodianAccountGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100,
        sortable: true,
        filter: true,
        resizable: true,
      },
      rowSelection: "multiple",
    };
  }

  getRowNodeId = data => {
    return data.guid;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    // const COLUMNS_KEY = 'fund-list-grid-col-state';

    // StateSynchronizer.syncGrid(
    //   params,
    //   this.state.columnDefs,
    //   () => localStorageClient.getGridColumnState(COLUMNS_KEY),
    //   s => localStorageClient.saveGridColumnState(COLUMNS_KEY, s)
    // );
  };

  render() {
    const {
      custodianAccountArray,
      className = 'grid-wrapper',
      loadCustodianAccountActionStatus,
    } = this.props;

    const isLoading = loadCustodianAccountActionStatus === ACTION_STATUS.LOGINING;
    if (loadCustodianAccountActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadCustodianAccountActionStatus();
    }

    return (
      <div className={`ag-theme-balham ${className}`}>
        {isLoading ? (
          <Loader active content="Loading..." />
        ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={custodianAccountArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            animateRows={true}
            immutableData={false}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
          />
        )}
      </div>
    );
  }
}

export default CustodianAccountGrid;